import React, {useContext} from "react";
import styled from "styled-components";
import UploadField from "../../../../UX/UploadField/UploadField";
import {ProductOptionStepsContext} from "../../../../Providers/ProductOptionStepsProvider";
import FileTable from "./FileTable";
import {FileUploadContext} from "../../../../Providers/FileUploadProvider/FileUploadProvider";
import {TranslationContext} from "../../../../Providers/TranslationProvider";

const Progress = styled.progress`
    width: 100%;
`;

const FileUpload = ({step, setRef, type, onOpenInfoModal, multiple}) => {
    const {trans} = useContext(TranslationContext);

    const {selectedOption} = useContext(ProductOptionStepsContext);
    const {files, uploading, setUploading, error, setError, onUploadFiles, onDeleteFile} = useContext(
        FileUploadContext
    );

    if (!selectedOption) {
        return null;
    }

    if (error) {
        return (
            <>
                <div className="w-full">
                    <div
                        style={{
                            borderRightColor: "#FEEBC8",
                            borderTopColor: "#FEEBC8",
                            borderBottomColor: "#FEEBC8"
                        }}
                        class="rounded bg-orange-100 border-l-4 border-orange-500 text-orange-700 border p-4 "
                        role="alert"
                    >
                        <p class="font-bold mb-1">
                            Er is iets misgegaan met uploaden
                        </p>
                        {error.map(e => (
                            <p className="mb-1" key={e.id}>
                                {e.message}
                            </p>
                        ))}
                        <p>
                            Je kunt je bestand ook aanleveren via{" "}
                            <a
                                href="https://24drukwerk.wetransfer.com/"
                                target="_Blank"
                            >
                                <u>WeTransfer</u>
                            </a>
                        </p>
                        <button onClick={() => {
                            setError(false);
                            setUploading(false);
                        }}
                                className="bg-blue-500 text-white px-4 py-2 text-white rounded mt-4 font-bold hover:bg-blue-600 text-sm">Opnieuw
                            uploaden
                        </button>
                    </div>
                </div>
            </>
        );
    }

    if (uploading) {
        return (
            <>
                <div className="w-full">
                    <h4>{trans("files_are_uploading", true)}</h4>
                </div>
                <div className="w-full">
                    <Progress className="success" max="100" value={uploading}/>
                </div>
            </>
        );
    }

    if (files.length > 0) {
        return (
            <>
                {multiple && (
                    <div className="w-full">
                        <UploadField
                            multiple={multiple}
                            className="w-full"
                            onFileDrop={onUploadFiles}
                        />
                    </div>
                )}
                <div className="w-full">
                    <FileTable files={files} onDeleteFile={onDeleteFile}/>
                </div>
            </>
        );
    }

    return (
        <>
            <div className="w-full">
                <UploadField
                    scale={300}
                    multiple={multiple}
                    className="w-full"
                    onFileDrop={onUploadFiles}
                />
            </div>
        </>
    );
};

export default FileUpload;
